function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isPlainObject } from '@cloud-sn/v-utils';
import { isValueOutOfRange, isMarkActive } from './utils';
import SubMixin from './mixins/sub';
export default {
  name: 'SliderMarks',
  mixins: [SubMixin],
  props: {
    lowerBound: {
      type: Number,
      default: 0
    },
    upperBound: {
      type: Number,
      default: 0
    }
  },
  computed: {
    markPrefixCls: function markPrefixCls() {
      var prefixCls = this.prefixCls;
      return "".concat(prefixCls, "-mark");
    },
    points: function points() {
      var marks = this.marks,
          min = this.min,
          max = this.max;
      return Object.keys(marks).map(parseFloat).filter(function (v) {
        return !isValueOutOfRange(v, min, max);
      }).sort(function (a, b) {
        return a - b;
      });
    },
    markElements: function markElements() {
      var h = this.$createElement;
      var markPrefixCls = this.markPrefixCls,
          points = this.points,
          marks = this.marks,
          vertical = this.vertical,
          calcOffset = this.calcOffset,
          included = this.included,
          upperBound = this.upperBound,
          lowerBound = this.lowerBound,
          onClick = this.onClick;
      var unit = points.length > 1 ? 100 / (points.length - 1) : 100;
      var markWidth = unit * 0.9;
      var elements = [];

      var _loop = function (i) {
        var _className;

        var point = points[i];
        var mark = marks[points[i]];
        mark = isPlainObject(mark) ? mark : {
          label: mark
        };
        var isActive = isMarkActive(point, included, lowerBound, upperBound);
        var className = (_className = {}, _defineProperty(_className, "".concat(markPrefixCls, "-text"), true), _defineProperty(_className, "".concat(markPrefixCls, "-text-active"), isActive), _className);
        var style = vertical ? {
          marginBottom: '-50%',
          bottom: "".concat(calcOffset(point), "%")
        } : {
          width: "".concat(markWidth, "%"),
          marginLeft: "".concat(-markWidth / 2, "%"),
          left: "".concat(calcOffset(point), "%")
        };
        var element = h("span", {
          "class": className,
          "style": [mark.style, style],
          "on": _objectSpread({}, {
            mousedown: function mousedown(e) {
              onClick(e, point);
            },
            touchstart: function touchstart(e) {
              onClick(e, point);
            }
          })
        }, [mark.label]);
        elements.push(element);
      };

      for (var i = 0, l = points.length; i < l; i += 1) {
        _loop(i, l);
      }

      return elements;
    }
  },
  methods: {
    onClick: function onClick(e, point) {
      this.$emit('click', e, point);
    }
  },
  render: function render() {
    var h = arguments[0];
    var markPrefixCls = this.markPrefixCls,
        markElements = this.markElements;
    return h("div", {
      "class": markPrefixCls
    }, [markElements]);
  }
};